export default __webpack_public_path__ + "static/media/227.dd571b78.png";